import { render, staticRenderFns } from "./TimeSpentDisplay.vue?vue&type=template&id=1e0c047a&"
import script from "./TimeSpentDisplay.vue?vue&type=script&lang=ts&"
export * from "./TimeSpentDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports